import * as protobuf from 'protobufjs/light';

/**
 * Force protobufjs to decode 64-bit integer fields as JS numbers.
 *
 * protobufjs >= 7.6 statically requires the `long` package, so webpack bundles
 * it and every int64 field (card expiry, Money.amount, DateTime.instantUsec, …)
 * decodes as a Long instance ({ low, high, unsigned }) instead of a number.
 * Earlier versions looked `long` up dynamically, which bundlers could not
 * resolve, so this app has always received plain numbers and renders and does
 * arithmetic on them directly. Disabling Long support restores that behavior.
 *
 * Must be imported before any message is decoded. See BUYERPORTAL-FE-1B8XJ.
 */
protobuf.util.Long = undefined as unknown as typeof protobuf.util.Long;
protobuf.configure();
